import React from 'react';

function Header(props) {
    return (
        <header>
          <h1>Jen Evenson</h1>
        </header>
    );
}

export default Header;



// WEBPACK FOOTER //
// ./src/Header.js